import { Module } from 'vuex';
import { RootState } from '@/store/types';
import getters from './getters';
import mutations from './mutations';
// tslint:disable-next-line:no-var-requires
const _ = require('lodash');

import { MobileState } from '@/store/Mobile/state';

const state: MobileState = {
  plans: [],
  options: [],
  terminals: [],
};

export const mobile: Module<MobileState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
};
